<template>
  <div>
    <div class="item-wrap" v-for="(item, index) in list" :key="index">
      <div class="item">
        <div class="item-pics">
          <Carousel height="344px" :list="item.urlList" :parentItem="item" type="room" />
        </div>
        <div class="item-content">
          <div class="item-head">
            <div class="title">{{ item.roomTypeName_translate || item.roomTypeName }}</div>
          </div>
          <ul class="intro">
            <li class="serve" v-if="item.capacityp">{{ ts('Capacity')['Capacity'] }}: {{ item.capacityp }} {{ ts('guests')['guests'] }}</li>
            <li class="area" v-if="item.floorArea">{{ ts('Floor area')['Floor area'] }}: {{ item.floorArea }}m²</li>
<!--            <li class="bed" v-if="item.beds">{{ ts('Bed: Queen size')['Bed: Queen size'] }} x {{ item.beds }}</li>-->
            <li class="bed" v-if="item.bedNameCount">{{ ts('Bed:')['Bed:'] }} {{  ts(item.bedNameCount)[item.bedNameCount] }}</li>
            <li class="bathroom" v-if="item.bathRooms">{{ ts('Bathroom')['Bathroom'] }} x {{ item.bathRooms }}</li>
          </ul>
          <div class="item-footer">
            <el-button class="btn btn-theme2" @click="getDetail(item)">{{ ts('Show Detail')['Show Detail'] }}</el-button>
            <a href="#" class="btn btn-360">{{ ts('360° VIEW')['360° VIEW'] }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 详情弹窗 -->
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" width="1000px">
      <div class="page-detail" v-if="roomDetail">
        <el-divider>{{ ts('Room Type Introduction')['Room Type Introduction'] }}</el-divider>
        <div class="detail-intro" style="width: 680px">
          <p v-for="intro in roomDetail.hotelDescriptionList" :key="intro.id">
            {{ intro.description }}
          </p>
          <div class="check-time">
            <div class="time"><img src="../assets/images/checkin.svg" height="35px" />{{ ts('Check-in time')['Check-in time'] }} : {{ roomDetail.pmsHouseResources.checkInTime }}</div>
            <div class="time"><img src="../assets/images/checkout.svg" height="35px" />{{ ts('Check-out time')['Check-out time'] }} : {{ roomDetail.pmsHouseResources.checkOutTime }}</div>
          </div>
        </div>
        <div v-if="roomDetail.roomTypeFeeList && roomDetail.roomTypeFeeList.length > 0">
          <el-divider>{{ ts('Other Fee')['Other Fee'] }}</el-divider>
          <ul class="detail-option">
            <li v-for="fee in roomDetail.roomTypeFeeList" :key="fee.id">{{ fee.name_translate }}: {{ currency }} {{ fee.feeValue }} {{ fee.feeUnit_translate }}</li>
          </ul>
        </div>
        <div v-if="roomAmenitiesLists.length > 0">
          <el-divider>{{ ts('Room Facility')['Room Facility'] }}</el-divider>
          <div class="room-facility" style="width: 800px; margin: 0 auto">
            <el-tabs v-model="roomFacility" class="tabs" :stretch="true">
              <template v-for="(tab, tabIndex) in roomAmenitiesLists">
                <el-tab-pane :label="tab.name" :name="`tab${tabIndex}`" v-if="tab.list.length > 0" :key="tab.id">
                  <ul>
                    <li v-for="a in tab.list" :key="a.attributeId">
                      <div class="icon-svg">
                        <svg width="33px" height="31px" viewBox="0 0 33 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                            <g id="资源-8" transform="translate(0.827388, -0.000216)" fill-rule="nonzero">
                              <path
                                d="M28.0926117,9.74021633 C30.0039402,14.0250944 29.6281124,18.9845333 27.0929003,22.9324511 C24.5576881,26.880369 20.2042381,29.2855207 15.5126117,29.3302163 C7.98923456,29.1282965 1.99527106,22.9713026 1.99527106,15.4452163 C1.99527106,7.91913002 7.98923456,1.76213617 15.5126117,1.56021633 C18.8161292,1.54796141 22.012658,2.73067705 24.5126117,4.89021633 L25.6226117,3.79021633 C22.8290117,1.33383128 19.232533,-0.0144035553 15.5126117,0 C8.61154372,-0.0361440599 2.52550088,4.51437486 0.608539073,11.1439539 C-1.30842274,17.773533 1.40990123,24.8698598 7.26542581,28.5221048 C13.1209504,32.1743497 20.6896131,31.4942875 25.8002771,26.8567046 C30.910941,22.2191217 32.3206937,14.7518774 29.2526117,8.57021633 L28.0926117,9.74021633 Z"
                                id="路径"
                              ></path>
                              <polygon id="路径" points="31.8526117 5.00021633 28.6026117 1.73021633 20.2726117 10.1102163 20.2826117 10.1202163 12.8326117 17.2102163 8.9526117 13.3002163 5.8026117 15.9102163 13.3926117 23.7302163 23.8926117 13.0102163"></polygon>
                            </g>
                          </g>
                        </svg>
                      </div>
                      {{ a.attributeId_translate }}
                    </li>
                  </ul>
                </el-tab-pane>
              </template>
            </el-tabs>
          </div>
        </div>
        <div v-if="roomDetail.hotelRulesList && roomDetail.hotelRulesList.length > 0">
          <el-divider>{{ ts('Rules and Regulations')['Rules and Regulations'] }}</el-divider>
          <div class="detail-rules" style="width: 800px">
            <div v-for="rule in roomDetail.hotelRulesList" :key="rule.id" v-html="rule.hotelText" style="white-space: pre-wrap"></div>
          </div>
        </div>
        <CancellationPolicy :detail="roomDetail.pmsHouseResources" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import Carousel from '@/components/Carousel.vue'
import { animateMap } from '@/utils/animateMap'
import CancellationPolicy from '@/components/CancellationPolicy.vue'

export default {
  name: 'RoomItem',
  props: ['list'],
  mixins: [LanguagePackage],
  components: {
    Carousel,
    CancellationPolicy,
  },
  data() {
    return {
      roomDetail: null,
      dialogVisible: false,
      roomAmenitiesLists: [],
      animateMap: animateMap,
      roomFacility: 'tab0',
      currency: '',
    }
  },
  created() {},
  methods: {
    getDetail(room) {
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const roomTypeId = room.roomTypeId
      postAction(`/pc/home/qryRoomDetailByParam`, {
        roomTypeId,
      })
        .then((res) => {
          loading.close()
          this.roomDetail = res.result
          this.currency = res.result.pmsHouseResources.currency
          this.getRoomFacility()
          this.dialogVisible = true
        })
        .catch(() => {
          loading.close()
        })
    },
    // 房间设施手动分类
    getRoomFacility() {
      let { roomAmenitiesLists } = this.roomDetail

      if (roomAmenitiesLists.length > 0) {
        // 分类
        let arr = [
          {
            name: this.translate('裝修構造'),
            id: 'cxgz',
            list: [],
          },
          {
            name: this.translate('床具類型'),
            id: 'cjlx',
            list: [],
          },
          {
            name: this.translate('家具電器'),
            id: 'jjdq',
            list: [],
          },
          {
            name: this.translate('衛浴設備'),
            id: 'wysb',
            list: [],
          },
          {
            name: this.translate('安全設備'),
            id: 'aqsb',
            list: [],
          },
          {
            name: this.translate('特色景觀'),
            id: 'tsjk',
            list: [],
          },
        ]

        const animateMap = this.animateMap

        // 根据 animateMap 来对 roomAmenitiesLists 进行分类，通过 attributeId 判断，返回 arr
        roomAmenitiesLists.forEach((item) => {
          // 设施标识
          const id = item.attributeId

          arr.forEach((x) => {
            // 分类标识 x.id
            const list = animateMap[x.id]

            let keys = []
            for (let key in list) {
              keys.push(key)
            }

            if (keys.includes(id)) {
              x.list.push(item)
            }
          })
        })
        this.roomAmenitiesLists = arr
      } else {
        this.roomAmenitiesLists = []
      }
    },
  },
}
</script>
